import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

/** One bucket per segment category is the most that can compile to a rule. */
const MAX_BUCKET_KEYS_PER_RULE = 6;
/** Each override copies a treatment subtree, so the count bounds published tree size. */
const MAX_SEGMENT_OVERRIDES = 10;

/** Ordered per-segment winners; array order is the rule precedence in the tree. */
export const segmentOverrideInputSchema = z.object({
  treatmentId: zExt.objectId(),
  label: z.string().min(1).max(200),
  bucketKeys: z.array(z.string()).min(1).max(MAX_BUCKET_KEYS_PER_RULE),
});

export const concludeCheckoutAbTestBySegment = {
  name: "concludeCheckoutAbTestBySegment" as const,
  input: z.object({
    splitId: zExt.objectId(),
    defaultTreatmentId: zExt.objectId(),
    segmentOverrides: z
      .array(segmentOverrideInputSchema)
      .max(MAX_SEGMENT_OVERRIDES),
  }),
  output: z.null(),
};
